import { useMotionValue } from 'motion/react';
import { useEffect } from 'react';
export const useViewportHeightMotionValue = () => {
    const viewportHeight = useMotionValue(0);
    useEffect(() => {
        const controller = new AbortController();
        const updateViewportHeight = () => viewportHeight.set(window.visualViewport?.height || document.documentElement.clientHeight);
        window.addEventListener('resize', updateViewportHeight, { passive: true, signal: controller.signal });
        updateViewportHeight();
        return () => controller.abort();
    }, [viewportHeight]);
    return viewportHeight;
};
